/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import CustomerSearch from 'components/site/customer-search';
import CargomaticInput from 'components/v2/input';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import { useTranslation } from 'react-i18next';
export default function AccessorialRatesModalCustomerRows({ index, item, handleCustomerField, searchCustomerType, onRemoveCustomerRow, }) {
    const { t } = useTranslation();
    const renderCustomerFilter = () => {
        return (React.createElement(CustomerSearch, { clearOnSelect: true, type: searchCustomerType, id: `laneRate-${index}`, onSelect: (item, value) => handleCustomerField('customer', item, value), onChange: (item, value) => handleCustomerField('customer', item, value), value: item.name, selected: item.name, placeholder: t('SEARCH_FOR_CUSTOMER'), dropdownStyle: { maxHeight: '160px', overflow: 'auto' } }));
    };
    const renderCustomerInput = () => {
        return (React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-bd893104", id: `laneRate-${index}`, value: item.name, type: "string", disabled: true, hideLabel: true }));
    };
    const renderRemoveAccessorial = () => {
        return (React.createElement("div", { "data-testid": "div-4c3df754", className: "w-1/3" },
            React.createElement(DeleteButton, { dataTestId: "DeleteButton-5c03efd5", onClick: () => onRemoveCustomerRow() })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { "data-testid": `tr-0cde6f53_${index}`, className: "block my-4 border-none" }),
        React.createElement("tr", { "data-testid": `tr-9faa883a_${index}`, className: "border-none" },
            React.createElement("td", { "data-testid": "td-be4e8ddb", className: "p-0" }, item.name ? renderCustomerInput() : renderCustomerFilter()),
            React.createElement("td", { "data-testid": "td-1ce82ba8", className: "p-0" }, renderRemoveAccessorial()))));
}
AccessorialRatesModalCustomerRows.propTypes = {
    index: PropTypes.number.isRequired,
    handleCustomerField: PropTypes.func.isRequired,
    onRemoveCustomerRow: PropTypes.func.isRequired,
};
